import { useCallback } from 'react';
import { useFieldActions } from '../../contexts/field-actions-context';
export const useUploadSignature = (uploadTarget)=>{
    const { actions, formId } = useFieldActions();
    const uploadFile = actions?.uploadFile;
    return useCallback(async (file)=>{
        if (!uploadFile) {
            throw new Error('No uploadFile action');
        }
        const fileDescriptor = await uploadFile({
            file,
            formId,
            uploadTarget
        });
        const { id, displayName, url, isPrivate } = fileDescriptor;
        return {
            fileId: id,
            displayName: displayName || file.name,
            url: !isPrivate ? url : undefined,
            fileType: file.type
        };
    }, [
        uploadFile,
        formId,
        uploadTarget
    ]);
};

//# sourceMappingURL=use-upload-signature.js.map